import { APP_DATE_FORMAT } from "../config/constants";
import moment from 'moment';

export const fmtUpdatedTime = (entity: any) =>
  entity && entity.baseInfo && entity.baseInfo.updatedTime ? moment(entity.baseInfo.updatedTime).format(APP_DATE_FORMAT) : '';

export const formatDate = (date: any) => moment(date).format('DD/MM/YYYY')

export const formatDateTime = (date: any) => moment(date).format('DD/MM/YYYY HH:mm')
